import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, GFunc, IconX, LocaleX, ReqX, ZTime, ZValidate } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, Spacer, VStack, XButton, XIconButton, XText } from "IZOX/_X";
import Styles from "__SYSDefault/Styles";
import Options from "shared/Options";
import { QForm } from "IZOX/BLOCKS/Libs";
import QUICKUI from "shared/QUICKUI";
import VarList from "shared/VarList";

/**
 * @augments {Component<Props, State>}
 */
class NewMaidW extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      curStep: 0,
      insured: {}
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this.GetNationalityList();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(NewMaidW.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  GetNationalityList = async () => {
    let docs = await VarList.GetList("Nationality");
    this.setState({
      nationalities: docs
    });
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _validateMaid = () => {
    let {insured} = this.state;
    let valid = ZValidate.CheckAllFields(insured, 
      [
        "m_fullName",
        "m_gender",
        "m_dateOfBirth",
        "m_nationality",
        "m_passport"
      ], "required"
    );
    if(!valid) return false;
    valid = ZValidate.CheckAllFields(insured, ["m_dateOfBirth"], "isDate");
    if(!valid) return false;
    return true;
  }

  _toSuccess = () => {
    this.setState({
      curStep: 1
    });
  }

  _close = () => {
    let {Refresh} = this.props;
    Refresh?.();
    GFunc.CloseBackdrop();
  }

  _onSubmit = async () => {
    let {insured} = this.state;
    this.setState({
      loading: true
    }, async () => {
      let res = await ReqX.SendBE("/Web/Agent/NewMaid", {
        insured
      });
      let {Success} = res;
      if(Success){
        this.setState({
          loading: false
        }, () => {
          this._toSuccess();
        });
      }else{
        this.setState({
          loading: false
        });
        GFunc.Ask({
          EN: "Network problem.",
          TC: "網絡問題"
        },
        {
          EN: "Please try again later.",
          TC: "請稍後再試。"
        });
      }
    });
    
  }

  _onInsuredChange = (formValue) => {
    this.setState({
      insured: formValue
    });
  }

  renderTitleBar(){
    return (
      <HStack pH={16} shadow>
        <XText fontSize={16} bold>
          {LocaleX.Parse({
            EN: "Add new helper",
            TC: "增加助理"
          })}
        </XText>
        <Spacer/>
        <XIconButton onPress={this._close}>
          {IconX.Get("ant", "close", 20, ColorX.CSS("Stone"))}
        </XIconButton>
      </HStack>
    );
  }

  renderSuccess(){
    return (
      <VStack fullWidth spacing={16} pT={30}>
        <VStack fullWidth spacing={30}>
          <HStack pH={16}>
            <XText fontSize={28} color={ColorX.CSS("Leaf")} bold>
              {LocaleX.Parse({
                EN: "Domestic Helper Added Successfully",
                TC: "已成功新增家務助理"
              })}
            </XText>
          </HStack>
          <HStack pH={16}>
            <XText fontSize={14} color={ColorX.CSS("Stone")} bold>
              {LocaleX.Parse({
                EN: "It will be shown on the Helper Management page",
                TC: "將會顯示在家務助理管理頁面"
              })}
            </XText>
          </HStack>
          <HStack>
            <XButton {...Styles.QFBtnInverse} width={200} onPress={this._close}
              padding={0} pV={8}>
              <HStack>
                <XText bold>
                  {LocaleX.Parse({
                    EN: "Back to dashboard",
                    TC: "返回"
                  })}
                </XText>
              </HStack>
            </XButton>
          </HStack>
        </VStack>
        <HStack spacing={16} 
          style={{
            borderTopWidth: 1, 
            borderTopStyle: "solid",
            borderTopColor: ColorX.CSS("greyOut", 0.3)
          }} 
          HAlign="]" pH={16}>
          <XButton fitWidthToContent onPress={this._close}
            color={ColorX.CSS("Axit")}>
            <HStack>
              <XText bold>
                {LocaleX.Parse({
                  EN: "Close",
                  TC: "關閉"
                })}
              </XText>
            </HStack>
          </XButton>
        </HStack>        
      </VStack>
    );
  }

  renderMaid(){
    let {nationalities, loading, insured} = this.state;
    return (
      <VStack pH={16}>
        <QForm fullWidth mB={16}
          onChange={(formValue) => this._onInsuredChange(formValue)}>
          <VStack fullWidth pB={4}>
            <HStack HAlign="[" p={8}>
              <XText color={ColorX.CSS("Leaf")}>
                {LocaleX.Parse({
                  EN: "Please note that the price and regulations for male helpers will be different.",
                  TC: "請注意，男傭的價格和規定會有所不同。"
                })}
              </XText> 
            </HStack>
            <HStack p={8}>
              {QUICKUI.WebTextField("m_fullName",
                {EN: "Name", TC: "姓名"},
                {width: "100%", 
                  errorMessage: ZValidate.GetErrorMsg(Accessor.Get(insured, "m_fullName"),
                  ["required"])
                })}
            </HStack>
            <HStack spacing={16} p={8}>
              <VStack width={325}>
                {QUICKUI.WebDateField("m_dateOfBirth", {
                  EN: "Date of birth",
                  TC: "出生日期"
                }, {
                  minDate: ZTime.Now().add(-60, "years").toISOString(),
                  maxDate: ZTime.Now().add(-18, "years").toISOString(),
                  defaultDisYear: ZTime.Now().add(-25, "years").year(), 
                  errorMessage: ZValidate.GetErrorMsg(Accessor.Get(insured, "m_dateOfBirth"),
                  ["required"])
                })}
              </VStack>
              <VStack width={329}>
                {QUICKUI.WebDropdown("m_gender", {
                  EN: "Gender",
                  TC: "性別"
                }, Options.GetOptionList("Gender"), {
                  placeholder: {
                    EN: "Gender",
                    TC: "性別"
                  },
                  errorMessage: ZValidate.GetErrorMsg(Accessor.Get(insured, "m_gender"),
                  ["required"])
                })}
              </VStack>
            </HStack>
            <HStack p={8} spacing={16}>
              {QUICKUI.WebTextField("m_passport",
                {EN: "Passport number / HKID", TC: "護照 / 香港身份證號碼"},
                {
                  errorMessage: ZValidate.GetErrorMsg(Accessor.Get(insured, "m_passport"),
                  ["required"])
                })}
              <VStack width={329}>
                {QUICKUI.WebDropdown("m_nationality", {
                  EN: "Nationality",
                  TC: "國籍"
                }, nationalities, {
                  placeholder: {
                    EN: "Nationality",
                    TC: "國籍"
                  },
                  valAccessor: "_id",
                  capAccessor: "name", 
                  errorMessage: ZValidate.GetErrorMsg(Accessor.Get(insured, "m_nationality"),
                  ["required"])
                })}
              </VStack>
            </HStack>
          </VStack>
        </QForm>
        {QUICKUI.PopupFooterButton(this._close, this._onSubmit, 
          {
            nextCap: {
              EN: "Submit",
              TC: "提交"
            },
            validateNext: this._validateMaid
          }, loading)}
      </VStack>
    );
  }

  renderMain(){
    let {curStep} = this.state;
    switch(curStep){
      default: case 0: return this.renderMaid();
      case 1: return this.renderSuccess();
    }
  }

  render(){
    return (
      <VStack bgColor={ColorX.CSS("NotQuiteWhite")}
        width={705} maxHeight={window.innerHeight * 0.9}>
        {this.renderTitleBar()}
        <VStack fullWidth>
          {this.renderMain()}
        </VStack>
      </VStack>
    );
  }

}

export default observer(NewMaidW);
